import{a as r}from"./chunk-WIMGWYZL.js";function u(...e){return r(o,e,i)}function o(e,a){return e.forEach(a),e}var i=e=>(a,n,t)=>(e(a,n,t),{done:!1,hasNext:!0,next:a});export{u as a};
